import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import findClosestScrollingContainer from '../editor/utils/findClosestScrollingContainer';
import useCanScrollUp from '../utils/useCanScrollUp';
import * as styles from './StickyHeader.module.scss';

interface StickyHeaderProps {
  children: React.ReactNode;
}

const StickyHeader = ({ children }: StickyHeaderProps) => {
  const { setScrollingContainer, canScrollUp } = useCanScrollUp();

  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const scrollingContainer =
      containerRef.current &&
      findClosestScrollingContainer(containerRef.current);

    if (scrollingContainer) {
      setScrollingContainer(scrollingContainer);
    }
  }, [setScrollingContainer]);

  return (
    <div
      ref={containerRef}
      className={classNames(styles.container, {
        [styles.stuck]: canScrollUp,
      })}
    >
      <div className={styles.header}>{children}</div>
    </div>
  );
};

export default StickyHeader;
